const labels = {
  'unavailable.data': 'Dati al momento non disponibili',
  'results.title.updated': 'Aggiornato',
  'match.table.head.team.one': 'Squadra 1',
  'match.table.head.team.two': 'Squadra 2',
  'match.table.head.match.link': 'Link partita',
  'match.table.head.match.result': 'Risultato partita',
  'match.table.head.match.status': 'Stato partita',
  'match.table.head.match.group': 'Girone',
  'results.match.round.group': 'Girone',
  'match.status.live': 'LIVE',
  'reports.view.match.votes': 'Vedi i voti',
  'reports.view.all.match.votes': 'Vedi tutti i voti',
  'reports.page.go.back': 'Torna a tutte le giornate',
  'report.top.player': 'TOP PLAYER',
  'report.tabs.panel.starting': 'Titolari',
  'report.tabs.panel.substitution': 'Sostituzioni',
  'report.tabs.panel.coach': 'Allenatore',
  'report.tabs.panel.referees': 'Arbitro',
  'report.tabs.panel.formation': 'Modulo',
  'report.tabs.panel.disqualifieds': 'Squalificati',
  'report.tabs.panel.unavailables': 'Indisponibili',
  'report.tabs.panel.potential.players': 'In dubbio',
  'report.tabs.postponed': 'La partita è stata rinviata',
  'report.tabs.unavailable': 'Pagelle non ancora disponibili',
  // ISS-4226 widget formation
  'formation.tabs.panel.substitution': 'Riserve',
  'formation.tabs.panel.referees': 'Ufficiali di gara',
  'formation.player.autGoal': 'Aut.',
  'additive.filter.title': 'Main',
  'additive.filter.dates.title': 'Secondary',
  'additive.filter.fallback.title': 'Nessun dato',
  'additive.filter.fallback.date.title': 'dati non dispobili',
  'match.reports.home.match.day.glider': 'G',
  'match.reports.home.match.day': 'Giornata',
  'match.reports.detail.back.cta': 'Torna a tutte le giornate',
  'team.results.filter.competitions': 'Competizioni',
  'team.results.filter.months': 'Mesi',
  'team.players.label': 'Rosa',
  'team.players.label.keeper': 'Portieri',
  'team.players.label.fullback': 'Difensori',
  'team.players.label.midfielder': 'Centrocampisti',
  'team.players.label.striker': 'Attaccanti',
  'team.players.label.coach': 'Allenatore',
  'team.players.label.years': 'anni',
  'team.players.th.number': 'Numero di maglia',
  'team.players.th.country': 'Nazionalità',
  'team.players.th.name': 'Nome e Cognome',
  'team.players.th.age': 'Età',
  'team.players.th.height': 'Altezza',
  'team.players.th.weight': 'Peso',
  'team.next-last-match.next': 'Prossima partita',
  'team.next-last-match.next-live': 'Partita in corso',
  'team.next-last-match.previous': 'Ultima partita',
  'team.next-last-match.empty': 'Informazione non disponibile',
  'top.scorers.th.position': 'Pos',
  'top.scorers.th.logo': 'Logo',
  'top.scorers.th.name': 'Calciatore',
  'top.scorers.th.goal': 'Gol',
  'top.scorers.th.penalty': 'Rigori',
  'top.scorers.th.head': 'Testa',
  'top.scorers.th.area.in': 'In area',
  'top.scorers.th.area.out': 'Fuori area',
  'top.scorers.th.empty': ' ',
  'competition.ranking.template.round': 'Girone',
  'competition.ranking.template.teams': 'Squadre',
  'competition.ranking.th.position': 'Pos',
  'competition.ranking.th.logo': 'Logo',
  'competition.ranking.th.team': 'Squadre',
  'competition.ranking.th.points': 'PT',
  'competition.ranking.th.points.card': 'Punti',
  'competition.ranking.th.games': 'G',
  'competition.ranking.th.games.card': 'Giornata',
  'competition.ranking.th.games.won': 'V',
  'competition.ranking.th.games.draw': 'N',
  'competition.ranking.th.games.lost': 'P',
  'competition.ranking.th.goals.scored': 'GF',
  'competition.ranking.th.goals.conceded': 'GS',
  'competition.ranking.th.goals.difference': 'DR',
  'competition.ranking.th.points.fullname': 'punti',
  'competition.ranking.th.games.fullname': 'giocate',
  'competition.ranking.th.games.won.fullname': 'vinte',
  'competition.ranking.th.games.draw.fullname': 'pareggiate',
  'competition.ranking.th.games.lost.fullname': 'perse',
  'competition.ranking.th.goals.scored.fullname': 'gol fatti',
  'competition.ranking.th.goals.conceded.fullname': 'gol subiti',
  'competition.ranking.th.goals.difference.fullname': 'differenza reti',
  'competition.ranking.th.trend': 'Andamento',
  'card.view.all': 'Vedi tutto',
  'card.view.all-results': 'Vai a tutti i risultati',
  'card.view.unavailable': 'Al momento il calendario non è disponibile.',
  'card.view.unavailable.cta': 'Guarda gli ultimi risultati.',
  'competition.calendar.results.table.title': 'Giornata',
  'match.data.round.title': 'Giornata',
  // HEADER/FOOTER
  'match.status.after.regular.time.shortname': 'Dtr',
  'match.status.after.extra.time.shortname': 'Dts',
  'match.status.after.shootout.time.shortname': 'Dcr',
  'match.status.aggregate.shortname': 'Tot',
  // ISS-4085
  'match.status.winner.knockout': 'vince',
  'match.status.winner.secondleg': 'passa il turno',
  'match.status.winner.after.extra.time': 'ai supplementari',
  'match.status.winner.after.shootout.time': 'ai rigori',
  // LEGEND
  'match.status.after.regular.time.fullname': 'dopo tempi regolamentari',
  'match.status.after.extra.time.fullname': 'dopo tempi supplementari',
  'match.status.after.shootout.time.fullname': 'dopo calci di rigore',
  'match.status.aggregate.fullname': 'risultato aggregato',
  // MATCH STATUS
  'match.status.abandoned': 'Sospesa',
  'match.status.cancelled': 'Annullata',
  'match.status.postponed': 'Rinviata',
  'match.time.live': '\u00a0',
  'match.time.halftime': 'INT',
  'match.time.first.half': '1T',
  'match.time.second.half': '2T',
  'match.time.fulltime.extra': 'TS',
  'match.time.extra.first.half': '1TS',
  'match.time.extra.halftime': 'TS INT',
  'match.time.extra.second.half': '2TS',
  'match.time.shootout': 'RIG',
  'match.time.fulltime.shootout': 'RIG',
  'match.time.fulltime': 'Fine',
  'href.anchor.prefix.id': 'giornata',
  'match.player.autoGoal': 'Aut.',
  'match.player.penalty': 'Rig.',
  'competition.ranking.legend.continental-cup-main': 'Champions League',
  'competition.ranking.legend.continental-cup-main-play-off': 'Preliminari di Champions League',
  'competition.ranking.legend.continental-cup-minor': 'Europa League',
  'competition.ranking.legend.continental-cup-minor-play-off': 'Preliminari Europa League',
  'competition.ranking.legend.continental-cup-third': 'Conference League',
  'competition.ranking.legend.continental-cup-third-play-off': 'Conference League',
  'competition.ranking.legend.relegation-play-out': 'Spareggi Retrocessione',
  'competition.ranking.legend.relegation': 'Retrocessione',
  'competition.ranking.legend.promotion': 'Promozione',
  'competition.ranking.legend.promotion-play-off': 'Spareggi Promozione',
  'competition.top.scorers.cta.view.all': 'tutta la classifica',
  'competition.top.scorers.title': 'classifica marcatori',
  'match.trend.label.won': 'Vittorie',
  'match.trend.label.draw': 'Pareggi',
  'match.trend.label.lost': 'Sconfitte',
  'match.trend.label.scored': 'Gol fatti',
  'match.trend.label.conceded': 'Gol subiti',
  'match.statistics.title': 'I numeri del Match',
  // Current branch
  'match.statistics.label.possession_percentage': 'Possesso palla',
  'match.statistics.label.on_target_scoring_att': 'Tiri in porta',
  'match.statistics.label.total_scoring_att': 'Tiri totali',
  // 'match.statistics.label.attempts-off-target': 'Tiri fuori',
  'match.statistics.label.total_post': 'Pali / Traverse',
  'match.statistics.label.total_offside': 'Fuori gioco',
  'match.statistics.label.fouls': 'Falli commessi',
  'match.statistics.label.total_yel_card': 'Ammonizioni',
  'match.statistics.label.total_red_card': 'Espulsioni',
  'match.statistics.label.won_corners': 'Angoli',
  // From DEVELOP
  'match.statistics.label.ball-possession': 'Possesso palla',
  'match.statistics.label.attempts-on-target': 'Tiri in porta',
  'match.statistics.label.attempts-off-target': 'Tiri fuori',
  'match.statistics.label.woodwork': 'Pali / Traverse',
  'match.statistics.label.offside': 'Fuori gioco',
  'match.statistics.label.fouls-committed': 'Falli commessi',
  'match.statistics.label.yellow-cards': 'Ammonizioni',
  'match.statistics.label.red-cards': 'Espulsioni',
  'match.statistics.label.corners': 'Angoli',
  'match.statistics.courtesy.message':
    'Le statistiche in tempo reale della partita saranno disponibili a gara iniziata',
  'match.statistics.label.vs': 'VS',
  /* LMP Formations */
  'match.formations.title': 'le formazioni ufficiali',
  'match.formations.errorMessage': 'Le formazioni ufficiali delle due squadre non sono ancora disponibili',
  'match.formation.field.errorMessage': 'La formazione ufficiale della squadra non è ancora disponibile',
  /* MATCH LIVE RANKING */
  'match.live.header': 'CLASSIFICA',
  'match.live.cta': 'Vai a tutta la classifica',
  /* PREDICTED LINEUPS */
  'match.lineups.lmp.title': 'Le probabili formazioni di',
  'match.lineups.lmp.cta': 'Vai al dettaglio del Match',
  'match.lineups.lmp.lineup-cta': 'Vai alle formazioni ufficiali',
  'match.lineups.back': 'Torna a lista giocatori',
  'match.lineups.cta': 'Disposizioni in campo',
  'match.times.hours': 'ore',
  'match.lineups.formations.title': 'Sono disponibili le formazioni ufficiali di ',
  'match.lineups.formations.cta': 'Vai alle formazioni.',
  /* PLAYER STATISTICS */
  'player.statistics.assists': 'Assist',
  'player.statistics.cleansheets': 'Clean Sheets',
  'player.chart.duels.failure': 'persi',
  'player.chart.duels.success': 'vinti',
  'player.chart.duels': 'Duelli vinti',
  'player.statistics.gamesplayed': 'Partite',
  'player.statistics.goals': 'Gol',
  'player.statistics.keypasses': 'Passaggi chiave',
  'player.statistics.starts': 'Titolare',
  'player.statistics.timeplayed': 'Minuti giocati',
  'player.statistics.title': 'Statistiche',
  'player.chart.totalpasses.failure': 'falliti',
  'player.chart.totalpasses.success': 'riusciti',
  'player.chart.totalpasses': 'Precisione passaggi',
  'player.chart.totalshots.failure': 'fuori',
  'player.chart.totalshots.success': 'in porta',
  'player.chart.totalshots': 'Tiri nello specchio',
  'player.statistics.totalshots': 'Tiri totali',
  'player.statistics.yellowcards': 'Ammonizioni',
  'player.statistics.recoveries': 'Palle recuperate',
  'player.statistics.totallossesofpossession': 'Palle perse',
  'player.statistics.totalfoulswon': 'Falli subiti',
  'player.statistics.totalfoulsconceded': 'Falli Commessi',
  'player.statistics.goalsconceded': 'Gol subiti',
  'player.statistics.penaltygoals': 'Gol su rigore',
  'player.statistics.totalredcards': 'Espulsioni',
  'player.statistics.savesmade': 'Parate',
  'player.statistics.penaltiessaved': 'Rigori Parati ', // TODO: Double check
  /* DRIVER STATISTICS */
  'driver.statistics.ranking': 'Classifica',
  'driver.statistics.points': 'Punti',
  'driver.statistics.races': 'GP disputati',
  'driver.statistics.gppoints': 'Punti nei GP',
  'driver.statistics.victories': 'Vittorie',
  'driver.statistics.podiums': 'Podi',
  'driver.statistics.topten': 'Top 10',
  'driver.statistics.poles': 'Pole',
  'driver.statistics.fastestlaps': 'Giri Veloci',
  'driver.statistics.dnfs': 'Ritiri',
  'driver.statistics.sprintraces': 'Sprint',
  'driver.statistics.sprintpoints': 'Punti Sprint',
  'driver.statistics.sprintvictories': 'Vittorie Sprint',
  'driver.statistics.sprintpodiums': 'Podi Sprint',
  'driver.statistics.sprintpoles': 'Pole Sprint',
  'driver.statistics.sprinttopten': 'Top 10 Sprint',
  /* MOTORSPORTS */
  'top.drivers.th.flag': 'Naz',
  'top.drivers.th.position': 'Pos',
  'top.drivers.th.name': 'Pilota',
  'top.drivers.th.team': 'Team',
  'top.drivers.th.best.time': 'Giro più veloce',
  'top.drivers.th.points': 'Punti',
  'top.drivers.th.time': 'Risultato',
  'top.motorsports.teams.th.position': 'Pos',
  'top.motorsports.teams.th.team': 'Team',
  'top.motorsports.teams.th.points': 'Punti',
  'drivers.standing.total.points.results': 'Classifica Piloti',
  'drivers.standing.race.results': 'Gara',
  'drivers.standing.race.starting.grid.results': 'Griglia',
  'drivers.standing.qualifying.results': 'Qualifiche',
  'drivers.standing.free.practice.results': 'Libere',
  'drivers.standing.last.update.results': 'Ultimo aggiornamento',
  'drivers.standing.best.lap.result': 'Giro più veloce',
  'motorsports.teams.total.points.results': 'Classifica Team',
  'motorsports.errorMessage.fixture': 'Evento in programma',
  'motorsports.errorMessage.fixtureGriglia':
    'I dati saranno disponibili al termine delle qualifiche previste il giorno',
  'motorsports.errorMessage.playing': 'Evento in corso. I dati cronometrici saranno disponibili al termine.',
  'motorsports.errorMessage.cancelled': `L'evento è stato cancellato.`,
  'motorsports.errorMessage.postponed': `L'evento è stato rinviato.`,
  'motorsports.errorMessage.suspended': `L'evento è stato sospeso.`,
  'motorsports.errorMessage.hours': `ore`,
  'motorsports.sessions.tabs.DS': 'Classifica piloti',
  'motorsports.sessions.tabs.FP1': 'Libere 1',
  'motorsports.sessions.tabs.FP2': 'Libere 2',
  'motorsports.sessions.tabs.FP3': 'Libere 3',
  'motorsports.sessions.tabs.FP4': 'Libere 4',
  'motorsports.sessions.tabs.G': 'Griglia',
  'motorsports.sessions.tabs.GS': 'Griglia',
  'motorsports.sessions.tabs.Q': 'Qualifiche',
  'motorsports.sessions.tabs.Q1': 'Qualifiche 1',
  'motorsports.sessions.tabs.Q2': 'Qualifiche 2',
  'motorsports.sessions.tabs.Q3': 'Qualifiche 3',
  'motorsports.sessions.tabs.QS': 'Qualifiche',
  'motorsports.sessions.tabs.R': 'Gara',
  'motorsports.sessions.tabs.R1': 'Gara 1',
  'motorsports.sessions.tabs.R2': 'Gara 2',
  'motorsports.sessions.tabs.SPRINT': 'Sprint Race',
  'motorsports.sessions.tabs.SS': 'Sprint Shootout',
  'motorsports.sessions.tabs.SS1': 'Sprint Shootout 1',
  'motorsports.sessions.tabs.SS2': 'Sprint Shootout 2',
  'motorsports.sessions.tabs.SS3': 'Sprint Shootout 3',
  'motorsports.sessions.accordion.SS1': 'Sprint Shootout 1',
  'motorsports.sessions.accordion.SS2': 'Sprint Shootout 2',
  'motorsports.sessions.accordion.SS3': 'Sprint Shootout 3',
  'motorsports.sessions.tabs.SPRINT.motogp': 'Gara Sprint',
  'motorsports.sessions.tabs.TS': 'Classifica costruttori',
  'motorsports.sessions.tabs.W': 'Warmup',
  'motorsports.session.status.live': 'LIVE',
  'f.1': 'Formula 1',
  'moto.gp': 'Moto GP',
  'moto.2': 'Moto 2',
  'moto.3': 'Moto 3',
  // MotorSport Hero
  'motorsports.hero.statistics.title': 'Statistiche gara',
  'motorsports.hero.statistics.laps.total': 'Giri totali',
  'motorsports.hero.statistics.laps.record': 'Record del circuito',
  'motorsports.hero.statistics.length': 'Lunghezza',
  'motorsports.hero.statistics.distance.unit': 'km',
  'motorsports.hero.statistics.status.live': 'live',
  'motorsports.hero.statistics.status.disputed': 'disputato',
  'motorsports.hero.flag': 'flag',
  'motorsports.hero.circuit.image': 'circuit image of',
  'motorsports.hero.times.hours': 'ore',
  // Motorsport Calendar
  'motorsports.calendar.gp.date': 'Data',
  'motorsports.calendar.gp': 'Gran premio',
  'motorsports.calendar.gp.circuit': 'Circuito',
  'motorsports.calendar.gp.length': 'Lunghezza',
  'motorsports.calendar.gp.laps': 'Giri',
  'motorsports.calendar.gp.live': 'TV',
  'motorsports.calendar.gp.sessions.session': 'Sessione',
  'motorsports.calendar.gp.sessions.date': 'Data',
  'motorsports.calendar.gp.sessions.time': 'Orario',
  'motorsports.calendar.gp.sessions.status.live': 'Live',
  'motorsports.calendar.gp.sessions.status.played': 'Vedi i risultati',
  'motorsports.calendar.gp.sessions.status.cancelled': 'Cancellata',
  'motorsports.calendar.gp.sessions.status.postponed': 'Rimandata',
  'motorsports.calendar.gp.sessions.status.suspended': 'Sospesa',
  'motorsports.calendar.gp.distance.unit': 'km',
  'motorsports.calendar.gp.season': 'Stagione',
  'motorsports.live': 'Diretta Sky',
  'motorsports.live.exclusive': 'Diretta esclusiva Sky',
  // Motorsport Calendar
  'motorsports.results.gp.current.link': 'Vai ai risultati live',
  'motorsports.results.gp.standings.link': 'Vai ai risultati completi',
  'motorsports.results': 'Risultati',
  // Motorsport Team Drivers
  'motorsports.team.drivers': 'Piloti',
  'motorsports.teams': 'Costruttori',
  // Tennis Circuits Calendar
  'tennis.circuits.calendar.table.circuit': 'Circuito',
  'tennis.circuits.calendar.table.series': 'Serie',
  'tennis.circuits.calendar.table.competition': 'Competizione',
  'tennis.circuits.calendar.table.date': 'Data',
  // Tennis Tour Ranking
  'tennis.tour.ranking.table.pos': 'Pos',
  'tennis.tour.ranking.table.name': 'Nome',
  'tennis.tour.ranking.table.score': 'Punti',
  // Tennis Match Status
  'tennis.match.status.abandoned': 'Sospesa',
  'tennis.match.status.cancelled': 'Annullata',
  'tennis.match.status.postponed': 'Rinviata',
  'tennis.match.status.live': 'Live',
  'tennis.match.status.fulltime': 'Conclusa',
  'tennis.match.status.scheduled': 'In programma',
  'tennis.match.status.scheduled.time': 'A partire dalle',
  'tennis.match.walkover': 'Conclusa per ritiro',
  // Tennis Cta
  'tennis.accordion.cta': 'Vedi risultati',
  'calendar.cta': 'Calendario',
  // Tennis Competition Category
  'tennis.category.singles': 'Singolare',
  'tennis.category.doubles': 'Doppio',
  'tennis.live.tournaments': 'Tornei in corso',
  'tennis.live.matches': 'Partite in corso',
  'tennis.circuits.calendar': 'Calendario circuiti',
  'tennis.circular.calendar.results.category': 'Categorie',
  'tennis.circular.calendar.results.category-all': 'Tutte le Categorie',
  'glider.arrow.left': 'Scivola a sinistra',
  'glider.arrow.right': 'Scivola a destra',
  'live-on-sky-badge.live': 'Diretta Sky',
  'live-on-sky-badge.exclusive': 'Diretta esclusiva Sky',
  // Livescore Football
  'previous-day-filter': 'Ieri',
  'current-day-filter': 'Oggi',
  'next-day-filter': 'Domani',
  'calendar.results.cta': 'Calendario e risultati',
  'competition.board.cta': 'Tabellone',
  'competition.board.noname': 'Da def.',
  'ranking.cta': 'Classifica',
  'h1.football': 'CALCIO',
  'filter-all': 'Tutti',
  'filter-ended': 'Conclusi',
  'match-list-empty': 'Nessuna partita disponibile',
  'football.match.list.empty': 'Non ci sono eventi in programma',
  // Livescore Motorsports
  'motorsports.sessions.list.empty': 'Non ci sono gare in programma',

  // Simple pagination
  'simple-pagination.button.label.prev': 'Precedente',
  'simple-pagination.button.label.next': 'Successiva',

  // Match Comments
  'badge.new.comments.text.singular': 'nuovo commento',
  'badge.new.comments.text.plural': 'nuovi commenti',
  'new.comments.title.singular': 'nuovo commento',
  'new.comments.title.plural': 'nuovi commenti',

  'view.all.results': 'Vai a tutti i risultati',

  // Competition Board
  'sponsored-by': 'sponsored by',
  'match-end': 'FINE',

  // LGP Hero
  'lgp.session.live': 'Live',
  'lgp.session.end': 'Fine',

  // Index Menu
  'index.menu.button.label.football': 'Competizioni',
  'index.menu.button.label.motorsports': 'Categorie',
  'index.menu.button.prev': 'Precedente',
  'index.menu.button.next': 'Successivo',

  // Tennis Calendar
  'tennis.calendar.courtesymsg.completed': 'La stagione è appena iniziata, non ci sono ancora tornei conclusi.',
  'tennis.calendar.courtesymsg.ongoing': 'Non ci sono tornei in corso.',
  'tennis.calendar.courtesymsg.scheduled': 'La stagione è finita, non ci sono più tornei in programma.',
  'tennis.cta.seo': 'Vedi tutti i tornei',
  'tennis.results.courtesymsg': 'Il torneo non è ancora iniziato, torna più tardi.',

  // Tennis Tournament Phases
  'tennis.qualification.r1': 'Qualificazioni 1° turno',
  'tennis.qualification.r2': 'Qualificazioni 2° turno',
  'tennis.qualification.r3': 'Qualificazioni 3° turno',
  'tennis.qualification.final': 'Qualificazioni Finale',
  'tennis.round.128': 'Round of 128',
  'tennis.round.64': 'Round of 64',
  'tennis.round.32': 'Round of 32',
  'tennis.round.16': 'Ottavi',
  'tennis.quarter.finals': 'Quarti',
  'tennis.semifinals': 'Semifinale',
  'tennis.final': 'Finale',
  'tennis.3rd.place': 'Finale 3°/4° posto',
  'tennis.group.stage': 'Group Stage',
  'tennis.playoff': 'Play-offs',
  'tennis.world.group': 'World Group I',
  'tennis.world.group.playoffs': 'World Group Play-offs',

  'tennis.livescore.courtesy.msg': 'Non ci sono eventi Live al momento, torna più tardi',
  'tennis.livescore.results-cta': 'Tutti i risultati',
  'tennis.atp.ranking.cta': 'Classifica ATP',
  'tennis.atp.calendar.cta': 'Calendario ATP',
  'tennis.wta.ranking.cta': 'Classifica WTA',
  'tennis.wta.calendar.cta': 'Calendario WTA',
  'mixed.doubles': 'Doppio Misto',
  'mens.singles': 'Singolare Maschile',
  'mens.doubles': 'Doppio Maschile',
  'womens.singles': 'Singolare Femminile',
  'womens.doubles': 'Doppio Femminile',
  // Scorers Ranking Player Page
  'scorers.ranking.player.page.title': 'Marcatori',
  'scorers.ranking.player.page.courtesy.label': 'Nessun dato sui marcatori disponibile al momento. Torna più tardi.',
  // Adv
  'adv.label': 'pubblicità',
  // Player Info
  'player.info.age': 'Data di nascita',
  'player.info.nationality': 'Nazionalità',
  'player.info.placeOfBirth': 'Luogo di nascita',
  'player.info.role': 'Role',
  'player.info.height': 'Altezza',
  'player.info.weight': 'Peso',
  'player.info.football.team': 'Squadra',
  'player.info.motorsports.team': 'Team',
  'player.info.league': 'Campionato',
  'player.info.jerseyNumber': 'Numero di maglia',
  'player.info.raceNumber': 'Numero di gara',
  // Players Carousel
  'players.carousel.readmore': 'Vedi anche',
  // Season Ranking Page
  'season.ranking.page.title': 'Classifica',
  'season.ranking.page.label': 'classifica',
  'sports.detail.card.mvp': 'mvp',
  'motorsports.drivers.slug': 'classifica-piloti',
  'motorsports.teams.slug': 'classifica-costruttori',
};

export default labels;

export type labelType = keyof typeof labels;
